export default __webpack_public_path__ + "static/media/adv-3.47759034.jpg";